import "core-js/modules/es6.object.assign";
import { __rest } from "tslib";
import * as React from 'react';
import { Header } from './base';
import { TableContext } from './Table';

var ContextHeader = function ContextHeader(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$headerRows = _a.headerRows,
      headerRows = _a$headerRows === void 0 ? undefined : _a$headerRows,
      props = __rest(_a, ["className", "headerRows"]);

  return React.createElement(Header, Object.assign({}, props, {
    headerRows: headerRows,
    className: className
  }));
};

export var TableHeader = function TableHeader(_a) {
  var props = __rest(_a, []);

  return React.createElement(TableContext.Consumer, null, function (_ref) {
    var headerRows = _ref.headerRows;
    return React.createElement(ContextHeader, Object.assign({}, props, {
      headerRows: headerRows
    }));
  });
};
TableHeader.displayName = 'TableHeader';